//
// 评分
// ============================================================
import Ns from "./utility";

let gradeInit = options => {
    let create = (descText) => {
        let isDescText = descText == "" ? "display-none" : "";
        let isColor = options.isColor == true ? "data-grade-color" : "";
        let isCenter = options.isCenter == true ? "justify-content-center" : "";
        return `
            <div class="grade-wrapper">
                <div class="grade-group `+ isCenter +`" `+ isColor +`>
                    <span class="grade-desc `+ isDescText +`">` + descText + `</span>
                    <span class="grade-item">
                        <i class="iconfont icon-star"></i>
                    </span>
                    <span class="grade-item">
                        <i class="iconfont icon-star"></i>
                    </span>
                    <span class="grade-item">
                        <i class="iconfont icon-star"></i>
                    </span>
                    <span class="grade-item">
                        <i class="iconfont icon-star"></i>
                    </span>
                    <span class="grade-item">
                        <i class="iconfont icon-star"></i>
                    </span>
                    <span class="grade-text display-none"></span>
                </div>
            </div>`
    };

    if (!options.create || (options.create && !options.create.length)) {
        let descText = (options.create && options.create.descText) ? options.create.descText : "";
        ns(options.el).html(create(descText));
    }else {
        let str = '';
        Ns.each(options.create, item => {
            let descText = item.descText ? item.descText : "";
            str += create(descText);
        }, true);

        ns(options.el).html(str);
    }

    Ns.each(ns(options.el).find(".grade-group").get(), (gradeGroup, j) => {
        gradeGroup.index = j;
        Ns.each(ns(gradeGroup).find(".grade-item").get(), (item, i) => {
            item.index = i;
        })
    });
};

let Grade = options => {
    gradeInit(options);

    // 辅助文本
    let auxiliaryText = (index, index2) => {
        if (!options.create) return "";

        if (options.create.length) {
            return (options.create[index] && options.create[index].auxiliaryText[index2]) ? options.create[index].auxiliaryText[index2] : "";
        }else {
            return options.create.auxiliaryText ? options.create.auxiliaryText[index2] : "";
        }
    };

    // 默认值
    let defaultValue = index => {
        if (!options.create) return "";

        if (options.create.length) {
            return (options.create[index] && options.create[index].defaultValue) ? options.create[index].defaultValue : "";
        }else {
            return options.create.defaultValue ? options.create.defaultValue : "";
        }
    };

    // 只读
    let readonly = () => {
        let itemHandle = (obj, value, index) => {
            Ns.each(obj, (item, i) => {
                let roundValue = Math.round(value) - 1;
                let isHalfEmpty = (roundValue + 1 - value) > 0 ? "icon-star-half-empty" : "icon-star-fill";
                ns(options.el).find(".grade-group").eq(index).find(".grade-text").removeClass("display-none").text(value);

                if(i < roundValue) {
                    ns(item).find(".iconfont").addClass("icon-star-fill").removeClass("icon-star")
                }else if(i == roundValue) {

                    isHalfEmpty == "icon-star-half-empty" ? ns(item).find(".iconfont").addClass(isHalfEmpty).removeClass("icon-star") : ns(item).find(".iconfont").addClass(isHalfEmpty).removeClass("icon-star");
                }
            }, true)
        };

        if (ns(options.el).find(".grade-group").get().length == 1) {
            let value = defaultValue();
            if (!value) return;

            ns(options.el).find(".grade-group").attr("data-grade-readonly", true);
            itemHandle(ns(options.el).find(".grade-group .grade-item").get(), value, 0);
            ns(options.el).attr("data-grade", value);
            return value;
        }else {
            let result = [];
            Ns.each(ns(options.el).find(".grade-group").get(), (gradeGroup, j) => {
                let value = defaultValue(j);
                if (!value) return;

                result.push(value);
                ns(gradeGroup).attr("data-grade-readonly", true);
                itemHandle(ns(gradeGroup).find(".grade-item").get(), value, j);
            }, true);

            result =  result.length > 1 ? result : undefined;
            if (result) {
                ns(options.el).attr("data-grade", result);
                return result;
            }
        }
    };

    return new Ns({
        el: options.el,
        eventHandle: [{
            type: "mouseover",
            entrust: ".grade-item",
            callback: function (ev) {
                let parentIndex = ns(this).parent().get(0).index;
                let index = ns(this).get(0).index;

                if (defaultValue(parentIndex) != "") return;

                Ns.each(ns(this).parent().find(".grade-item").get(), (item, i) => {
                    index >= i ? ns(item).find(".iconfont").addClass("icon-star-fill").removeClass("icon-star") : ns(item).find(".iconfont").removeClass("icon-star-fill").addClass("icon-star");
                });

                // 显示评分文本
                let auxiliaryText2 = auxiliaryText(parentIndex, index);
                auxiliaryText2 != "" ? ns(this).parent().find(".grade-text").removeClass("display-none").text(auxiliaryText2) : "";

                return true;
            }
        }, {
            type: "click",
            entrust: ".grade-item",
            callback: function (ev) {
                let index = ns(this).get(0).index;
                let parentIndex = ns(this).parent().get(0).index;

                if (defaultValue(parentIndex) != "") return;

                ns(this).parent().attr("data-grade", index);
                Ns.each(ns(this).parent().find(".iconfont").get(), (item, i) => {
                    if (index >= i) {0
                        ns(item).addClass("icon-star-fill").removeClass("icon-star");
                    } else {
                        ns(item).removeClass("icon-star-fill").addClass("icon-star");
                    }
                });
                let gradeGroup = ns(this).parents(".grade-wrapper").find(".grade-group").get();
                if (gradeGroup.length <= 1) {
                    let value = index + 1;
                    ns(this).parents(".grade-wrapper").attr("data-grade", value);
                    return value
                }else {

                    let gradeArr = [];
                    Ns.each(gradeGroup, (item) => {
                        if(ns(item).attr("data-grade")) {
                            let dataGrade = Number(ns(item).attr("data-grade")) + 1;
                            gradeArr.push(dataGrade)
                        }
                    }, true);
                    ns(this).parents(".grade-wrapper").attr("data-grade", gradeArr);
                    return gradeArr;
                }
            }
        }, {
            type: "mouseout",
            entrust: ".grade-group",
            callback: function (ev) {
                // 记录评分
                let gradeIndex = ns(this).attr("data-grade");
                let selfIndex = ns(this).get(0).index;

                if (defaultValue(selfIndex) != "") return;

                if (gradeIndex) {
                    Ns.each(ns(this).find(".iconfont").get(), (item, i) => {
                        if (gradeIndex >= i) {
                            ns(item).addClass("icon-star-fill").removeClass("icon-star");
                        } else {
                            ns(item).removeClass("icon-star-fill").addClass("icon-star");
                        }
                    });

                    // 辅助文字
                    let auxiliaryText2 = auxiliaryText(selfIndex, gradeIndex);
                    auxiliaryText2 != "" ? ns(this).find(".grade-text").removeClass("display-none").text(auxiliaryText2) : "";
                } else {

                    // 没评分
                    ns(this).find(".iconfont").removeClass("icon-star-fill").addClass("icon-star");
                    ns(this).find(".grade-text").addClass("display-none");
                }
                return gradeIndex != null ? (Number(gradeIndex)+1) : 0;
            }
        }],
        load () {
            return readonly();
        }
    });

};

module.exports = Grade;


// WEBPACK FOOTER //
// src/js/grade.js